(() => {
  const money = (cents, cur) => {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  };

  /* Gallery */
  function initGallery(root) {
    const track = root.querySelector('.mc-gallery__track');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    const slides = [...track.children];
    const dots = [...root.querySelectorAll('.mc-gallery__dot')];
    const go = (i) => { i = (i + slides.length) % slides.length; track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' }); };
    const current = () => Math.round(track.scrollLeft / track.clientWidth);
    root.querySelector('.mc-gallery__arrow--prev')?.addEventListener('click', () => go(current() - 1));
    root.querySelector('.mc-gallery__arrow--next')?.addEventListener('click', () => go(current() + 1));
    dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
    track.addEventListener('scroll', () => { const c = current(); dots.forEach((d, i) => d.classList.toggle('is-active', i === c)); }, { passive: true });
  }

  /* Reel */
  function initReel(root) {
    const track = root.querySelector('.mc-reel__track');
    if (!track || track.dataset.ready) return;
    track.dataset.ready = '1';
    const step = () => (track.querySelector('.mc-reel__card')?.offsetWidth || 260) + 24;
    root.querySelector('.mc-reel__arrow--prev')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('.mc-reel__arrow--next')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => entries.forEach((e) => {
        const v = e.target.querySelector('video'); if (!v) return;
        e.isIntersecting ? v.play().catch(() => {}) : v.pause();
      }), { threshold: 0.6 });
      track.querySelectorAll('.mc-reel__card').forEach((c) => io.observe(c));
    }
  }

  /* Ritual tabs */
  function initRitual(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const tabs = [...root.querySelectorAll('.mc-tab')];
    const panes = [...root.querySelectorAll('.mc-ritual__pane')];
    const show = (i) => {
      tabs.forEach((t, j) => { t.classList.toggle('is-active', i === j); t.setAttribute('aria-selected', i === j); });
      panes.forEach((p, j) => {
        p.classList.toggle('is-active', i === j);
        const v = p.querySelector('video');
        if (v) { if (i === j) { v.currentTime = 0; v.play().catch(() => {}); } else v.pause(); }
      });
    };
    tabs.forEach((t, i) => t.addEventListener('click', () => show(i)));
    show(0);
  }

  /* Buy box */
  function initBuy(form) {
    if (form.dataset.ready) return; form.dataset.ready = '1';
    const cur = form.dataset.currency;
    const btnPrice = form.querySelector('[data-mc-price]');
    const btnCompare = form.querySelector('[data-mc-compare]');
    const planRow = form.querySelector('[data-mc-plans]');
    const kitBox = form.querySelector('[data-mc-kit]');
    const kitBag = form.querySelector('[data-mc-kit-bag]');
    const err = form.querySelector('.mc-buy__error');
    const submit = form.querySelector('button[type="submit"]');

    const selected = () => form.querySelector('input[name="mc-option"]:checked');
    const subscribing = () => form.querySelector('input[name="mc-plan"]:checked')?.value === 'sub';
    const addon = () => form.querySelector('input[name="mc-addon"]');
    const wantsKit = (opt) => !!form.dataset.kitId && opt.dataset.kit === '1';

    const update = () => {
      const opt = selected(); if (!opt) return;
      const hasPlan = !!opt.dataset.plan;
      if (planRow) planRow.hidden = !hasPlan;
      let price = Number(opt.dataset.price);
      let compare = Number(opt.dataset.compare || 0);
      if (hasPlan && subscribing()) { compare = compare || price; price = Number(opt.dataset.planPrice || price); }
      const a = addon(); if (a && a.checked) { price += Number(a.dataset.price); if (compare) compare += Number(a.dataset.price); }
      if (btnPrice) btnPrice.textContent = money(price, cur);
      if (btnCompare) { btnCompare.hidden = !(compare > price); btnCompare.textContent = compare > price ? money(compare, cur) : ''; }
      if (kitBox) {
        kitBox.hidden = !wantsKit(opt);
        if (kitBag) { const q = Number(opt.dataset.qty || 1); kitBag.textContent = 'Marci Chicory Blend · ' + (q > 1 ? q + ' × ' : '') + (opt.dataset.label || '').replace(/^\d+\s*×\s*/, ''); }
      }
      if (form.hasAttribute('data-mc-primary-buy')) document.querySelectorAll('[data-mc-sticky-price]').forEach((el) => el.textContent = money(price, cur));
    };
    if (!selected()) { const first = form.querySelector('input[name="mc-option"]:not([disabled])'); if (first) first.checked = true; }
    form.addEventListener('change', update);
    update();

    const add = (items) => fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items })
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (form.hasAttribute('data-design-mode')) return;
      const opt = selected(); if (!opt) return;
      const items = [{ id: Number(opt.value), quantity: Number(opt.dataset.qty || 1) }];
      if (opt.dataset.plan && subscribing()) items[0].selling_plan = Number(opt.dataset.plan);
      const a = addon(); if (a && a.checked) items.push({ id: Number(a.value), quantity: 1 });
      const kit = wantsKit(opt) ? { id: Number(form.dataset.kitId), quantity: 1, properties: { _founding_kit: 'yes' } } : null;
      submit.disabled = true; if (err) err.textContent = '';
      try {
        let res = await add(kit ? [...items, kit] : items);
        if (!res.ok && kit) res = await add(items); /* kits just ran out: still place the order */
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add to bag'); }
        window.location.href = form.dataset.redirect || '/checkout';
      } catch (ex) {
        if (err) err.textContent = ex.message;
        submit.disabled = false;
      }
    });
  }

  /* Sticky bar */
  function initSticky(bar) {
    if (bar.dataset.ready) return; bar.dataset.ready = '1';
    const target = document.querySelector('[data-mc-primary-buy]');
    const btn = bar.querySelector('button');
    btn?.addEventListener('click', () => {
      const form = document.querySelector('[data-mc-primary-buy]');
      if (form) form.requestSubmit ? form.requestSubmit() : form.querySelector('button[type="submit"]').click();
    });
    if (!target || !('IntersectionObserver' in window)) { bar.classList.add('is-visible'); return; }
    let past = false;
    new IntersectionObserver(([e]) => {
      past = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', past);
    }).observe(target.querySelector('button[type="submit"]') || target);
  }

  /* Founding Kit promo: top bar + popup */
  function initPromo(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    if (/mc_promo=preview/.test(location.search)) root.setAttribute('data-preview', '');
    const start = root.dataset.start ? new Date(root.dataset.start + 'T00:00:00') : null;
    const live = !start || isNaN(start) || Date.now() >= start.getTime() || root.hasAttribute('data-preview');
    if (!live) return;
    const bar = root.querySelector('.mc-promo__bar');
    if (bar) bar.hidden = false;
    const pop = root.querySelector('.mc-promo__pop');
    if (!pop) return;
    let seen = false;
    try { seen = sessionStorage.getItem('mc-promo-seen') === '1'; } catch (e) {}
    if (seen && !root.hasAttribute('data-preview')) return;
    const close = () => { pop.hidden = true; try { sessionStorage.setItem('mc-promo-seen', '1'); } catch (e) {} };
    pop.querySelectorAll('[data-mc-promo-close]').forEach((b) => b.addEventListener('click', close));
    pop.addEventListener('click', (e) => { if (e.target === pop) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !pop.hidden) close(); });
    const delay = Number(root.dataset.delay || 6) * 1000;
    setTimeout(() => { pop.hidden = false; }, root.hasAttribute('data-preview') ? 300 : delay);
  }

  const init = (scope = document) => {
    scope.querySelectorAll('.mc-gallery').forEach(initGallery);
    scope.querySelectorAll('.mc-reel').forEach(initReel);
    scope.querySelectorAll('.mc-ritual').forEach(initRitual);
    scope.querySelectorAll('form[data-mc-buy]').forEach(initBuy);
    scope.querySelectorAll('.mc-sticky').forEach(initSticky);
    scope.querySelectorAll('[data-mc-promo]').forEach(initPromo);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
